import { grey } from '@material-ui/core/colors'
import { BORAL_GREEN } from 'Constants/Theme/Theme.constants'
import Colors from 'Support/Theme/Colors/Colors'

const PleaseWatiSpinnerStyle = ({ theme }: { theme: any}) => ({
  wrapper: {
    marginTop: theme.spacing(1) * 4,
  },
})

export default PleaseWatiSpinnerStyle
